import {boundMethod} from "autobind-decorator";
import React from "react";
import {IntlShape, injectIntl} from "react-intl";

import {ILocalizedText} from "@translate/models";
import {CHART_EXPORT_HEIGHT, EDetailedFingerprint} from "./models";

import InlineCheckbox from "@toolbox/button-like/InlineCheckbox";
import T, {intl2Str} from "@translate/T";
import {getCentDetailImage} from "./images";

interface IDetailedFingerprintProps {
    intl: IntlShape;
    value: EDetailedFingerprint;
    onChange(value: EDetailedFingerprint): void;
}

class DetailedFingerprint extends React.PureComponent<IDetailedFingerprintProps> {
    @boundMethod
    public onChange(checked: boolean) {
        this.props.onChange(
            checked
                ? EDetailedFingerprint.Detailed
                : EDetailedFingerprint.Simple,
        );
    }

    public render() {
        const {intl, value} = this.props;
        const title: ILocalizedText = (_intl) =>
            intl2Str(
                _intl,
                "Shows out of time range profies grayed out, first valid profile in blue, zero profile in black.",
            );

        return (
            <div className="form-row mb-2">
                <div className="col-sm-2">
                    <label>
                        <T>Fingerprint view</T>
                    </label>
                </div>

                <div className="col-sm-4">
                    <InlineCheckbox
                        idSuffix="reference"
                        checked={value === EDetailedFingerprint.Detailed}
                        title={title}
                        toggle={this.onChange}
                    >
                        <T>Detailed</T>
                    </InlineCheckbox>
                </div>

                <div className="col-sm-4 align-self-center">
                    <img
                        alt={intl2Str(intl, "Fingerprint scheme")}
                        src={getCentDetailImage(value).fingerPrint}
                        height={CHART_EXPORT_HEIGHT}
                    />
                </div>
                <div className="col-sm-2 align-self-center">
                    <img
                        alt={intl2Str(intl, "Fingerprint scheme")}
                        src={getCentDetailImage(value).transmittogram}
                        height={CHART_EXPORT_HEIGHT}
                    />
                </div>
            </div>
        );
    }
}

export default injectIntl(DetailedFingerprint);
